import { configureStore } from "@reduxjs/toolkit";

import appManagerUiRenderSlice from "./features/appManagerUiRenderSlice";
import appMangerUtilitySlice from "./features/appMangerUtilitySlice";
import {
  onBoardingRequestedSlice,
  OnboardingTableFilterSlice,
  OnboardingTableFilterDeclineSlice,
  OnboardingStaticDataSlice,
  OnboardingUiRenderSlice,
  OnboardingutilitySlice,
} from "@bjsdistribution/tms-onboarding";

import { OnboardingUiRenderSliceLib } from "@bjsdistribution/tms-component-library";

import { addVehicleFiltersDataSlice, addVehicleFormSlice, addVehicleStaticDataSlice, addVehicleUtilitySlice } from "@bjsdistribution/tms-add-vehicle";
import {
  breakDownTableFilterDeclineSlice,
  breakDownTableFiltersSlice,
  breakDownUiRenderSlice,
  breakDownUtilitySlice,
  checksTableFiltersSlice,
  checksUiRenderSlice,
  checksUtilitySlice,
  defectBreakDownCreateSlice,
  defectTableFilterDeclineSlice,
  defectTableFiltersSlice,
  defectUiRenderSlice,
  defectUtilitySlice,
  driverListSlice,
  maintenanceGlobalUiRenderSlice,
  maintenanceGlobalUtilitySlice,
  maintenanceStaticDataSlice,
  maintenanceTableFiltersSlice,
  maintenanceUiRenderSlice,
  maintenanceUtilitySlice,
  workshopListSlice,
} from "@bjsdistribution/tms-vehicle-maintenance";

import { hrStaticDataReducer, hrUiRenderReducer, hrPersonalDetailReducer, hrDashboardReducer, hrHeadcountReducer } from "@bjsdistribution/tms-hr";
import { InvoiceUiRenderSlice, staticDataSlice, DisplayInvoicesSlice, ReadyForInvoiceSlice, InvoiceFiltersSlice, SelfBillUiRenderSlice, SelfBillingFilterSlice } from "@bjsdistribution/tms-finance";
import { JobsModalsUiRenderSlice, addressSlice, filtersSlice, jobChargeSlice, jobSlice, jobsStaticDataSlice } from "@bjsdistribution/tms-jobs";
import { customerConfigStaticDataReducer, customerConfigUiRenderReducer } from "@bjsdistribution/tms-customer-config";
import { SubcontractorUiRenderSlice } from "@bjsdistribution/tms-subcontractor";
import { uiRenderReducer, otherDashboardStaticDataReducer, otherDashboardFiltersReducer, fuelupFiltersReducer, HSDashboardFilters, ExpenseFilters } from "@bjsdistribution/tms-fleet";
const TmsStore = configureStore({
  reducer: {
    OnboardingUiRenderSliceLib,
    // App manager slices
    appManagerUiRenderSlice,
    appMangerUtilitySlice,
    // Tms Onboarding
    onBoardingRequestedSlice,
    OnboardingTableFilterSlice,
    OnboardingTableFilterDeclineSlice,
    OnboardingStaticDataSlice,
    OnboardingUiRenderSlice,
    OnboardingutilitySlice,
    // Tms Add vehicle
    addVehicleStaticDataSlice,
    addVehicleUtilitySlice,
    addVehicleFormSlice,
    addVehicleFiltersDataSlice,
    // maintenance Global
    maintenanceGlobalUtilitySlice,
    defectBreakDownCreateSlice,
    maintenanceGlobalUiRenderSlice,
    maintenanceStaticDataSlice,
    // Defects slice
    defectTableFiltersSlice,
    defectTableFilterDeclineSlice,
    defectUiRenderSlice,
    defectUtilitySlice,
    // Breakdown slice
    breakDownTableFiltersSlice,
    breakDownTableFilterDeclineSlice,
    breakDownUiRenderSlice,
    breakDownUtilitySlice,
    workshopListSlice,
    driverListSlice,
    // Checks
    checksTableFiltersSlice,
    checksUiRenderSlice,
    checksUtilitySlice,

    // maintenance
    maintenanceTableFiltersSlice,
    maintenanceUiRenderSlice,
    maintenanceUtilitySlice,

    //hr
    hrStaticDataReducer,
    hrUiRenderReducer,
    hrPersonalDetailReducer,
    hrDashboardReducer,
    hrHeadcountReducer,
    //finance
    InvoiceUiRenderSlice,
    staticDataSlice,
    DisplayInvoicesSlice,
    ReadyForInvoiceSlice,
    InvoiceFiltersSlice,
    SelfBillUiRenderSlice,
    SelfBillingFilterSlice,

    //Jobs
    JobsModalsUiRenderSlice,
    jobsStaticDataSlice,
    jobSlice,
    jobChargeSlice,
    filtersSlice,
    addressSlice,
    //customer config
    customerConfigUiRenderReducer,
    customerConfigStaticDataReducer,

    //subcontractor
    SubcontractorUiRenderSlice,

    //fleet
    uiRenderReducer,
    otherDashboardStaticDataReducer,
    otherDashboardFiltersReducer,
    fuelupFiltersReducer,
    HSDashboardFilters,
    ExpenseFilters,
  },
});

export default TmsStore;
